/**
 * 車輌内装キズModal
 */

/* Import Modules */
import { ref } from "vue";
import $ from "jquery";

/* Import Variables */
import { rentalContractEditForm } from "../../variables";

/* Define Variables */
export const interiorCheckModalRef = ref<any>(null);
export const interiorCheckRow = 3; // 行数
export const interiorCheckCol = 6; // 列数

/* Define Functions */
export const showInteriorCheckModal = () => {
  interiorCheckModalRef.value?.showModal();
};

const hideInteriorCheckModal = () => {
  interiorCheckModalRef.value?.hideModal();
};

/**
 * キズ情報更新
 * @param row
 * @param col
 */
export const setInteriorCheck = (row: number, col: number) => {
  // 反映対象のノードIDを取得
  let elementId = "#interior_modal_" + row + "_" + col;
  // 更新内容 反映
  $(elementId).text($("input[name='interior-radio']:checked").val());
};

/**
 * 車輌内装キズ情報 保存処理
 */
export const setInteriorData = () => {
  let checkValue = "";
  for (let m = 1; m <= interiorCheckRow; m++) {
    for (let n = 1; n <= interiorCheckCol; n++) {
      /* ElementIdを取得 */
      let elementId = "#interior_" + m + "_" + n;
      let elementModalId = "#interior_modal_" + m + "_" + n;

      /* カンマベースの入力値を取得 */
      checkValue += $(elementModalId).text();
      checkValue += ",";

      /* キズ情報 コピー処理 */
      $(elementId).text($(elementModalId).text());
    }
  }
  checkValue = checkValue.slice(0, -1);
  /* Move Interior Value */
  $("#interiorCheck").val(checkValue);
  rentalContractEditForm.interiorCheck = checkValue;
  hideInteriorCheckModal();
};

/**
 * 車輌内装キズ情報 表示処理
 * @param interiorCheck
 */
export const setInteriorDataByRentalContractModal = (interiorCheck: string) => {
  /* expload params by separator = "," */
  const interiorPart = interiorCheck.split(",");
  let index = 0;
  for (let i = 1; i <= interiorCheckRow; i++) {
    for (let j = 1; j <= interiorCheckCol; j++) {
      /* Define Variables. */
      let elementId = "#interior_" + i + "_" + j;
      let elementModalId = "#interior_modal_" + i + "_" + j;

      /* Move Interior Value */
      $(elementId).text(interiorPart[index]);
      $(elementModalId).text(interiorPart[index]);

      ++index;
    }
  }
};
